import { createClient } from "@connectrpc/connect";
import { UsuariosAppPlataformaService } from "../../generated/grpc/plataforma_seguridad_usuarios_app_pb";
import { UsuarioAppResponse } from "../../response/seguridad/UsuarioAppResponse";
import { UsuarioAppPayload } from "../api/payload/seguridad/UsuarioAppPayload";
import { ServiceSaveBase } from "../base/ServiceSaveBase";
import { grpcTransportProvider } from "../grpc/GrpcTransport";
import { mapConnectError } from "../grpc/mapConnectError";
import { toUsuarioAppResponse } from "./UsuarioAppListByClienteIdService";

/** Alta y edición de cuentas de la app web. Sin `cache`: la pestaña vuelve a sincronizar tras guardar. */
export class UsuarioAppSaveService extends ServiceSaveBase<UsuarioAppResponse, UsuarioAppPayload> {
  /**
   * gRPC-Web (`UsuariosAppPlataformaService.Guardar`): sin `id` crea, con `id` edita. La
   * contraseña solo viaja si se escribió; el servidor valida política, email único y cliente.
   */
  protected async sendSave(request: UsuarioAppPayload): Promise<UsuarioAppResponse> {
    const client = createClient(UsuariosAppPlataformaService, grpcTransportProvider.get());
    try {
      const item = await client.guardar({
        id: request.id ?? undefined,
        clienteId: request.clienteId,
        nombre: request.nombre,
        email: request.email,
        password: request.password || undefined,
      });
      return toUsuarioAppResponse(item);
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}
